var res = "";
var lang = "";
var checkMark = "&#x2714; ";
var crossMark = "&#x2716; ";
var dot = "&#x2022 ";
var warning = "&#8252 ";
var space = "&#x20";
// var crossMark = 'xxxx';
var t1 = false;
var t2 = false;
var t3 = false;

// regex
const hasSpace = (str) => /\s/.test(str);
const hasEightCharacters = (str) => /.{8,}/.test(str);
const hasUpperCase = (str) => /[A-Z]/.test(str);
const hasLowerCase = (str) => /[a-z]/.test(str);
const hasNumber = (str) => /\d/.test(str);
const hasSpecialCharacter = (str) => /['!\\"#$%&()*,./:;?@`\[{|}\]~+<=>^_-]/.test(str);

const checkLength = (password) => {
  var text = lang === "ENG" ? "The minimum password length is 8 characters" : "ความยาวไม่น้อยกว่า 8 ตัวอักษร";
  var t = hasEightCharacters(password);
  res += t
    ? `<p style="color: transparent; text-shadow: 0 0 0 #fff;">${checkMark} ${text}</p>`
    : `<p style="color: transparent; text-shadow: 0 0 0 #fff;">${crossMark} ${text}</p>`;
  return t ? true : false;
};

const checkSpace = (password) => {
  var text = lang === "ENG" ? "Must not contain spaces" : "ไม่มีเว้นวรรค";
  var t = hasSpace(password);
  res += hasSpace(password)
    ? `<p style="color: transparent; text-shadow: 0 0 0 #fff;">${crossMark} ${text}</p>`
    : `<p style="color: transparent; text-shadow: 0 0 0 #fff;">${checkMark} ${text}</p>`;
  return t ? false : true;
};

const checkComplexity = (password) => {
  var arr = [
    {
      number: 1,
      eng_text: "upper case (A , Z)",
      thai_text: "ตัวอักษรพิมพ์ใหญ่ (A , Z)",
    },
    {
      number: 2,
      eng_text: "lower case (a , z)",
      thai_text: "ตัวอักษรพิมพ์เล็ก (a , z)",
    },
    {
      number: 3,
      eng_text: "numerals (0 , 9)",
      thai_text: "ตัวเลข (0 , 9)",
    },
    {
      number: 4,
      eng_text: "special characters (such as % @ #)",
      thai_text: "อักขระพิเศษ (เช่น % @ #)",
    },
  ];
  var yes_arr = [];
  var no_arr = [];
  var c1 = 0,
    c2 = 0,
    c3 = 0,
    c4 = 0;
  if (hasUpperCase(password)) {
    yes_arr.push(1);
    c1 = 1;
  } else {
    no_arr.push(1);
  }
  if (hasLowerCase(password)) {
    yes_arr.push(2);
    c2 = 1;
  } else {
    no_arr.push(2);
  }
  if (hasNumber(password)) {
    yes_arr.push(3);
    c3 = 1;
  } else {
    no_arr.push(3);
  }
  if (hasSpecialCharacter(password)) {
    yes_arr.push(4);
    c4 = 1;
  } else {
    no_arr.push(4);
  }

  var t = "";
  var f = "";
  if (yes_arr.length >= 3) {
    for (const i of arr) {
      for (const j of yes_arr) {
        if (i["number"] === j) {
          t += `<p style="color: transparent; text-shadow: 0 0 0 #fff;">  ${checkMark} ${lang === "ENG" ? i["eng_text"] : i["thai_text"]} </p>`;
        }
      }
    }
  } else {
    for (const i of arr) {
      var skip = false;
      for (const j of no_arr) {
        if (i["number"] === j) {
          f += `<p style="color: transparent; text-shadow: 0 0 0 #fff;">  ${crossMark} ${lang === "ENG" ? i["eng_text"] : i["thai_text"]} </p>`;
          skip = true;
        }
      }
      if (!skip) {
        t += `<p style="color: transparent; text-shadow: 0 0 0 #fff;">  ${checkMark} ${lang === "ENG" ? i["eng_text"] : i["thai_text"]} </p>`;
      }
    }
  }
  if (lang === "ENG") {
    // res += ("&#x2022; Contain at least 3 out of 4 following characteristics: \n\n" + f + t).trim();
    res +=
      `<p><b>${dot} ${space} Contain at least <span style="text-decoration: underline; text-underline-offset: 2px; text-decoration-thickness: 1.5px;">3 out of 4 following characteristics:</span></b></p>` +
      f +
      t;
  } else {
    // res += ("&#x2022; มีคุณสมบัติดังต่อไปนี้อย่างน้อย 3 ใน 4 อย่าง: \n\n" + f + t).trim();
    res +=
      `<p><b>${dot} ${space} มีคุณสมบัติดังต่อไปนี้อย่างน้อย <span style="text-decoration: underline; text-underline-offset: 2px; text-decoration-thickness: 1.5px;">3 ใน 4 อย่าง:</span></b></p>` +
      f +
      t;
  }
  return c1 + c2 + c3 + c4 >= 3 ? true : false;
};

const validateADPassword = (password, language) => {
  lang = language;
  res = "";
  res += lang === "ENG" ? `<p><b>${warning}</b> ${space} Password failed to meet the requirements.</p>` : `<p><b>${warning}</b> รหัสผ่านไม่ตรงตามข้อกำหนด</p>`;
  t1 = checkLength(password);
  t2 = checkSpace(password);
  t3 = checkComplexity(password);
  return t1 && t2 && t3 ? "" : res;
};

export { validateADPassword };
